<template>
    <v-app>
        <InvalidMobileAccess v-if="$isMobile()"/>
        <div v-else>
            <SideNav v-if="isLoggedIn" />
            <v-main>
                <router-view />
            </v-main>
        </div>
        
    </v-app>
</template>

<script>
import store from "@/store";
import { computed } from "vue";
import SideNav from "@/components/SideNav.vue";
import InvalidMobileAccess from "@/components/InvalidMobileAccess.vue";

export default {
    name: "App",

    components: {
        SideNav,
        InvalidMobileAccess,
    },
    setup() {
        const isLoggedIn = computed(() => store.state.user != null);
        const width = computed(() => screen.width);

        return {
            isLoggedIn,
            width,
        };
    },
};
</script>

